import { useState, useCallback, useEffect } from 'react';
import { EventData, EVENTS, STATUS, Step } from 'react-joyride';

const TOUR_KEY = 'solimat-notifications-tour-v1';

const STEPS: Step[] = [
  {
    target: '.notif-list',
    title: 'Panel de notificaciones',
    content: 'Aquí se muestran todas las notificaciones recibidas, organizadas en dos pestañas: las no leídas (pendientes) y las ya leídas.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '.tabs',
    title: 'No leídas / Leídas',
    content: 'Cambia entre las pestañas para ver las notificaciones pendientes de leer o el historial de notificaciones ya consultadas. El número en rojo indica notificaciones sin leer.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.notif-filters',
    title: 'Filtros de notificaciones',
    content: 'Busca notificaciones por título o mensaje, y filtra por fecha para localizar rápidamente una notificación concreta.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.notif-search',
    title: 'Búsqueda por texto',
    content: 'Escribe palabras clave del título o del contenido de la notificación para filtrar los resultados al instante.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.notif-date-filter',
    title: 'Filtro por fecha',
    content: 'Selecciona una fecha para ver únicamente las notificaciones recibidas ese día.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.notif-cards',
    title: 'Lista de notificaciones',
    content: 'Las notificaciones aparecen como tarjetas con el título, el mensaje y la fecha. Haz clic en cualquiera para marcarla como leída y navegar a la sección relacionada.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '.notif-card',
    title: 'Tarjeta de notificación',
    content: 'Las notificaciones sin leer se destacan visualmente. Al hacer clic se marcan automáticamente como leídas y, si están asociadas a un expediente o cita, te llevan directamente a él.',
    placement: 'right',
    skipBeacon: true,
  },
];

export const useNotificationsTour = () => {
  const [run, setRun] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  const handleCallback = useCallback((data: EventData) => {
    const { type, status, index } = data as any;
    const finished = status === STATUS.FINISHED || status === STATUS.SKIPPED;

    if (finished || (type as string) === EVENTS.TOUR_END) {
      setRun(false);
      localStorage.setItem(TOUR_KEY, 'true');
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }

    if ((type as string) === EVENTS.STEP_AFTER && index === 0) {
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }
  }, []);

  const startTour = useCallback(() => {
    setRun(current => {
      if (current) return false;
      setTourKey(k => k + 1);
      return true;
    });
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: run } }));
  }, [run]);

  return { run, tourKey, steps: STEPS, handleCallback, startTour };
};
